import { SubmitHandler, useForm } from "react-hook-form";
import { onSubmitError } from "@talladega/helpers";
import { SubStepButtons } from "@talladega/components";
import BuyerSellerInformationFormFields, {
  focusOrder,
} from "./BuyerSellerInformationFormFields";
import {
  BuyerInformationFormInput,
  BuyerSellerFieldsInput,
} from "../types/BillOfSaleFormFields";
import { CombinedFormInformation } from "../hooks/useBillOfSaleFormStepsReducer";

type Props = {
  onBack?: () => void;
  onNext: (formData: BuyerSellerFieldsInput) => void;
  formInformation: CombinedFormInformation;
  hideBackButton?: boolean;
  required?: boolean;
};

const buyerInformationFieldsKey = "buyerInformation";

const BuyerStep = ({
  onBack,
  onNext,
  formInformation,
  hideBackButton = false,
  required = false,
}: Props) => {
  const buyerInformationForm = useForm<BuyerInformationFormInput>({
    defaultValues: {
      buyerInformation: formInformation.buyerInformation,
    },
  });

  const {
    formState: { isSubmitting },
  } = buyerInformationForm;

  const onSubmitBuyerInfo: SubmitHandler<BuyerInformationFormInput> = (
    buyerInformationInput: BuyerInformationFormInput
  ) => {
    const { buyerInformation } = buyerInformationInput;
    onNext(buyerInformation);
  };

  return (
    <form
      onSubmit={buyerInformationForm.handleSubmit(
        onSubmitBuyerInfo,
        onSubmitError(
          focusOrder.map((field) => `${buyerInformationFieldsKey}.${field}`)
        )
      )}
    >
      <div className="mt-6 p-8 w-full border rounded-xl border-gray-200">
        <div className="flex flex-col gap-4">
          <BuyerSellerInformationFormFields
            fieldsKey={buyerInformationFieldsKey}
            formMethods={buyerInformationForm}
            required={required}
          />
        </div>
        <div className="mt-6">
          <SubStepButtons
            hideBackButton={hideBackButton}
            backButton={{ disabled: isSubmitting, onClick: onBack }}
            nextButton={{ disabled: isSubmitting }}
          />
        </div>
      </div>
    </form>
  );
};

export default BuyerStep;
